import { styled } from "styled-components";

export const LiveSettingPopupWrapper = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 10px;
  height: 500px;
  position: relative;
  top: 0;
  left: 0;
  margin-top: 40px;
`;

export const LiveSettingHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  > .right {
    display: flex;
    align-items: center;
    gap: 10px;

    > .info {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 14px;
      color: #ff0000;
    }

    > .button {
      cursor: pointer;
      width: 158px;
      height: 40px;
      border-radius: 15px;
      color: #fff;
      font-family: Pretendard;
      font-weight: 700;
      font-size: 15px;
      line-height: 40px;
      text-align: center;
      background: #969696;

      &.on {
        background: #7f25fb;
      }
    }
  }
`;
export const LiveSettingTableWrapper = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  background: #f0f0f0;
  width: 100%;
  border-radius: 6.74px;
  padding: 0 20px;
  box-sizing: border-box;
`;

export const LiveSettingTableHeader = styled.div`
  display: flex;
  padding: 22px 0 15px;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 15px;
  text-align: center;

  font-family: Pretendard;
  font-weight: 500;
  font-size: 15px;

  > .ord {
    width: 13%;
  }
  > .name {
    width: 15%;
  }
  > .link {
    width: 35%;
  }
  > .toggle {
    width: 30%;
  }
`;

export const LiveTableBorder = styled.div`
  border-bottom: 2px solid #d9d9d9;
  width: 100%;
`;

export const LiveSettingListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  position: relative;
`;

export const LiveSettingListAllWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 20px 0;
  width: 100%;
`;

export const LiveSettingLiveUpdateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 300px;
  position: relative;
  overflow-y: auto;
  scrollbar-width: none;
`;

export const LiveSettingListItemWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  gap: 20px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 15px;
  height: 40px;
  padding: 4px 0;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 13px;
  line-height: 40px;
  text-align: center;

  input {
    width: 100%;
    height: 32px;
    border-radius: 10px;
    background: #f0f0f0;
    text-align: center;
    border: none;
    outline: none;
    color: var(--kakao-logo, #000);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  > .ord {
    width: 10%;
  }

  > .link {
    width: 35%;
  }

  > .button {
    width: 5%;
    height: 32px;
    background: #7f25fb;
    line-height: 32px;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
  }
`;

export const LiveSettingListNameWrapper = styled.div`
  width: 15%;
  position: relative;
  height: 32px;
  border-radius: 10px;
  background: #f0f0f0;
  text-align: center;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 400;
  line-height: 32px;
  cursor: pointer;

  > span {
    position: absolute;
    right: 5px;
    top: 0;
    font-size: 20px;
  }
`;

export const YoutuberSelectWrapper = styled.div`
  position: absolute;
  top: 35px;
  right: 0;
  width: 90%;
  background: #fff;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 5px;
  box-shadow: 0px 3.71px 3.71px 0px #00000040;
  border: 1px solid #d9d9d9;
  line-height: 100%;

  > .item {
    padding: 3px 7px;
    border-radius: 5px;
    cursor: pointer;
    &.active {
      background: #6436e7;
      color: #fff;
    }
  }
`;

export const LiveSettingToggleWrapper = styled.div<{
  isLiveOn: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 25%;

  > .title {
    color: ${(p) => (p.isLiveOn ? "#f00" : "#444")};
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 600;
  }
`;

export const LiveSettingToggleItem = styled.div<{
  isLiveOn: boolean;
}>`
  position: relative;
  cursor: pointer;
  width: 49px;
  height: 24px;
  background-color: ${(p) => (p.isLiveOn ? "#f00" : "#444")};
  border-radius: 100px;
  transition: background-color 0.3s ease-in-out;
`;

export const LiveSettingToggleCircle = styled.div<{
  isLiveOn: boolean;
}>`
  position: absolute;
  top: 2px;
  left: ${(p) => (p.isLiveOn ? "27px" : "4px")};
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 50%;
  transition: left 0.3s ease-in-out;
`;

export const LiveSettingButton = styled.div`
  width: 483px;
  height: 59px;
  border-radius: 20px;
  background: #6436e7;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 20.23px;
  line-height: 59px;
  text-align: center;
  color: #ffffff;
  margin: 40px auto 0;
  cursor: pointer;
`;
